<template>
  <div class="row">
    <div class="col-md-12 col-sm-12 col-lg-12">
      <h3 class="title">Mệnh lý nghiên cứu</h3>
      <ul class="duong-so">
        <li>Họ tên: <span>{{ name }}</span></li>
        <li>
          Giới tính:
          <span>{{ gender.toString() === '1' ? 'Nam' : 'Nữ'}}</span>
        </li>
        <li>Ngày sinh:
          <span>{{ duonglich.day }}/{{ duonglich.month }}/{{ duonglich.year }} {{ duonglich.hour }}:{{ minute }} </span>
        </li>
<!--        <li>Âm lịch tiết khí:-->
<!--          <span>{{ duonglich.hour }} giờ {{ minute }} phút ngày {{ amlich.alTk.day.value }} tháng {{ amlich.alTk.month.value }} năm {{ amlich.alTk.year.value }}</span>-->
<!--        </li>-->
        <li>Tuổi:
          <span>{{ tuoi }}</span>
        </li>
        <li>
          Tiết
          <span>{{ amlich.alTk.tk.name }}</span>
        </li>
        <li style="color: #2b6406;">
          Ngày khởi tiết <span>{{ amlich.alTk.tk.name }}</span>:
          <span>{{ amlich.alTk.tk.startTk }}</span>
        </li>
        <li style="color: #2b6406;">
          Khí <span>{{ amlich.alTk.tk.nextKhiName }}</span> từ:
          <span>{{ amlich.alTk.tk.nextKhi }}</span>
          đến
          <span>{{ amlich.alTk.tk.nextTk }}</span>
        </li>
        <li>
          Khởi đại vận sau:
          <span>{{ khoiDaiVan.year }}</span> năm
          <span>{{ khoiDaiVan.month }}</span> tháng
          <span>{{ khoiDaiVan.day }}</span> ngày
        </li>
        <li>
          Tức khởi từ ngày:
          <span>{{ khoiDaiVan.ngayBatDauDaiVan }}</span>
        </li>
<!--        <li>Cung Mệnh :-->
<!--          <span>{{ tuTruNames[4] }}</span>-->
<!--        </li>-->
<!--        <li>Thai Nguyên :-->
<!--          <span>{{ tuTruNames[5] }}</span>-->
<!--        </li>-->
        <li>
          <a class="bat-trach" href="" target="_blank">Xem lá số khác</a>
        </li>
        <li>
          <a class="bat-trach" @click="onClickDownload">Download</a>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  props: {
    name: {
      type: String,
      default: null
    },
    minute: {
      type: String,
      default: null
    },
    gender: {
      type: [String, Number],
      default: '1'
    },
    duonglich: {
      type: Object,
      default: null
    },
    amlich: {
      type: Object,
      default: null
    },
    tuTruNames: {
      type: Array,
      default: null
    },
    khoiDaiVan: {
      type: Object,
      default: null
    },
    tuoi: {
      type: [String, Number],
      default: null
    }
  },
  methods: {
    onBack () {
      this.$emit('onBack')
    },
    onClickDownload () {
      this.$emit('onDownload')
    }
  }
}
</script>
